import { render } from "./VerifyUserModal.vue?vue&type=template&id=2cbfd08d&scoped=true"
import script from "./VerifyUserModal.vue?vue&type=script&lang=js"
export * from "./VerifyUserModal.vue?vue&type=script&lang=js"

import "./VerifyUserModal.vue?vue&type=style&index=0&id=2cbfd08d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cbfd08d"]])

export default __exports__